import { render, staticRenderFns } from "./ServicesSection.vue?vue&type=template&id=7a98c134&"
import script from "./ServicesSection.vue?vue&type=script&lang=js&"
export * from "./ServicesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports